// The server refuses a paused account's requests with extensions.code
// ACCESS_PAUSED (spartapt-gql Auth::PausedAccess, 2026-11-03). The Apollo
// error link raises this signal; AccessGuard listens and shows the paused
// screen at once instead of letting every screen fail with raw errors.
const listeners = new Set();

export function notifyAccessPaused() {
  listeners.forEach((l) => l());
}

export function onAccessPaused(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
